import React from 'react'
import { cx } from '@/lib/utils'
import styles from './Badge.module.scss'

type Tone = 'neutral' | 'primary' | 'success'

interface BadgeProps {
  children: React.ReactNode
  tone?: Tone
}

const toneMap: Record<Tone, string> = {
  neutral: styles.neutral, primary: styles.primary, success: styles.success,
}

export const Badge: React.FC<BadgeProps> = ({ children, tone = 'neutral' }) => (
  <span className={cx(styles.badge, toneMap[tone])}>{children}</span>
)
